import { json } from "@hyper-hyper-space/hhs3_json";
import { sha256, stringToUint8Array } from "@hyper-hyper-space/hhs3_crypto";
export function hashElement(element) {
    return sha256.hashToB64(stringToUint8Array(json.toStringNormalized(element)));
}
